import * as React from 'react';
import { injectIntl } from 'react-intl';

import Label from '../../../components/label/Label';
import SingleSelectField from '../../../components/select-field/SingleSelectField';

import messages from '../messages';
import './EnumField.scss';

var EnumField = function EnumField(_ref) {
    var dataKey = _ref.dataKey,
        dataValue = _ref.dataValue,
        displayName = _ref.displayName,
        description = _ref.description,
        intl = _ref.intl,
        onChange = _ref.onChange,
        onRemove = _ref.onRemove,
        _ref$options = _ref.options,
        options = _ref$options === undefined ? [] : _ref$options;

    var selectOptions = options.map(function (option) {
        return {
            displayText: option.key,
            value: option.key,
            isSelectable: true
        };
    });

    var defaultValue = intl.formatMessage(messages.metadataFieldSelectValue);

    selectOptions.unshift({
        displayText: defaultValue,
        value: defaultValue,
        isSelectable: false
    });

    return React.createElement(
        'div',
        { className: 'metadata-instance-editor-field-enum' },
        React.createElement(
            Label,
            { text: displayName },
            !!description && React.createElement(
                'i',
                { className: 'metadata-instance-editor-field-enum-desc' },
                description
            ),
            React.createElement(SingleSelectField, {
                onChange: function (_onChange) {
                    function onChange(_x) {
                        return _onChange.apply(this, arguments);
                    }

                    onChange.toString = function () {
                        return _onChange.toString();
                    };

                    return onChange;
                }(function (option) {
                    if (option.isSelectable) {
                        onChange(dataKey, option.value);
                    } else if (onRemove) {
                        onRemove(dataKey);
                    }
                }),
                options: selectOptions,
                selectedValue:
                // Conditional to make flow happy, dataValue should never be an array
                Array.isArray(dataValue) ? dataValue.join(', ') : dataValue || defaultValue
            })
        )
    );
};

EnumField.propTypes = {
    dataKey: PropTypes.string.isRequired,
    dataValue: function dataValue() {
        return (typeof bpfrpt_proptype_FieldValue === 'function' ? bpfrpt_proptype_FieldValue : PropTypes.shape(bpfrpt_proptype_FieldValue)).apply(this, arguments);
    },
    description: PropTypes.string,
    displayName: PropTypes.string.isRequired,
    intl: function intl(props, propName, componentName) {
        if (!Object.prototype.hasOwnProperty.call(props, propName)) {
            throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
        }
    },
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(function () {
        return (typeof bpfrpt_proptype_TemplateFieldOption === 'function' ? bpfrpt_proptype_TemplateFieldOption : PropTypes.shape(bpfrpt_proptype_TemplateFieldOption)).apply(this, arguments);
    })
};
export { EnumField as EnumFieldBase };
export default injectIntl(EnumField);
import { bpfrpt_proptype_FieldValue } from '../flowTypes';
import { bpfrpt_proptype_TemplateFieldOption } from '../flowTypes';
import PropTypes from 'prop-types';